<section id="portfolio" class="sf-section">
  <div class="sf-section__header">
    <div>
      <h2 class="sf-section__title">{{'public-profile.portfolio.title' | transloco}}</h2>
      <p class="sf-section__subtitle">{{'public-profile.portfolio.subtitle' | transloco}}</p>
    </div>
    <app-image-upload
      [buttonSize]="'medium'"
      [label]="'public-profile.portfolio.add-photo.label'"
      [shouldCompress]="false"
      [maxNumberOfImages]="null"
      (batchReady)="onPortfolioBatchReady($event)"
    ></app-image-upload>
  </div>
  @if (portfolioPhotos && portfolioPhotos.length > 0) {
    <div class="portfolio-list"
         cdkDropList
         (cdkDropListDropped)="drop($event)"
         [cdkDropListSortingDisabled]="false"
         [cdkDropListOrientation]="'mixed'"
    >
      @for (portfolioPhoto of portfolioPhotos; track portfolioPhoto) {
        <div class="portfolio-list__item" cdkDrag>
          <button class="button button--danger button--square portfolio-list__item-delete-button"
                  (click)="deletePortfolioPhoto(portfolioPhoto)">
            <i class="fa-solid fa-trash-can"></i>
          </button>
          <app-image
            [src]="portfolioPhoto.url"
            [alt]="'Photo ' + portfolioPhoto.id"
            preset="card"
            aspectRatio="1/1"
            [width]="256"
            [height]="256"
          ></app-image>
        </div>
      }
    </div>
  } @else if (portfolioPhotos === null) {
    <div class="portfolio-list">
      @for (_ of [0, 1, 2, 3]; let i = $index; track i) {
        <div class="portfolio-list__item skeleton-loading"></div>
      }
    </div>
  } @else {
    <div class="empty-state">
      <i class="fa-solid fa-panorama empty-state__icon"></i>
      <h1 class="empty-state__title">{{'public-profile.portfolio.empty.title'|transloco}}</h1>
      <p class="empty-state__description">{{'public-profile.portfolio.empty.description'|transloco}}</p>
    </div>
  }
</section>
